module.exports = [{"type":"hash","text":"訂閱方式"},{"type":"normal","text":"成功建立與Websocket服務器的連接後，Websocket客戶端發送如下請求以訂閱特定主題 "},{"type":"code","text":"{ \"id\": \"id1\", \"reqType\": \"sub\", \"dataType\": \"data to sub\" }"},{"type":"normal","text":"成功訂閱後，Websocket客戶端将收到確認："},{"type":"code","text":"{ \"id\": \"id1\", \"code\": 0, \"msg\": \"\" }"},{"type":"normal","text":"之後, 一旦所訂閱的數據有更新，Websocket客戶端将收到服務器推送的更新消息 "}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/introduce/04_subscribe.json
// module id = UYWd
// module chunks = 3